import type { ReactNode } from "react";
import { BRANDING } from "../../shared/branding.js";

type Props = {
  currentPath: string;
  onNavigate: (path: string) => void;
  children: ReactNode;
};

const NAV = [
  { path: "/", label: "Home" },
  { path: "/calendar", label: "Calendar" },
  { path: "/open-hares", label: "Open Hares" },
];

export function Layout({ currentPath, onNavigate, children }: Props) {
  return (
    // data-band-theme: "teal" | "sunset" | "pattern" (remove attr for default blue)
    <div className="app-shell">
      <header className="site-header">
        <a
          href="/"
          className="site-brand"
          onClick={(e) => {
            e.preventDefault();
            onNavigate("/");
          }}
        >
          <img src={BRANDING.badgePath} alt="" className="site-brand-mark" width={90} height={90} />
          <span className="site-brand-text">
            <span className="site-brand-title">
              <span className="show-mobile">{BRANDING.shortName}</span>
              <span className="show-from-tablet">{BRANDING.name}</span>
            </span>
            <span className="site-brand-sub">{BRANDING.tagline}</span>
          </span>
        </a>
        <nav className="site-nav" aria-label="Primary">
          {NAV.map((n) => {
            const active = n.path === currentPath || (n.path !== "/" && currentPath.startsWith(n.path));
            return (
              <a
                key={n.path}
                href={n.path}
                aria-current={active ? "page" : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate(n.path);
                }}
              >
                {n.label}
              </a>
            );
          })}
        </nav>
      </header>
      <main className="site-main">{children}</main>
      <footer className="site-footer">
        <span className="site-footer-copyright">
          © {new Date().getFullYear()} {BRANDING.name} · Oahu, HI
        </span>
        {BRANDING.contactLinks.map((c) => (
          <a
            key={c.href}
            href={c.href}
            target={c.href.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
          >
            {c.label}
          </a>
        ))}
        <span className="site-footer-version">v{__APP_VERSION__}</span>
      </footer>
    </div>
  );
}
